<template>
  <div class="container py-10">
    <div class="flex items-center mb-10">
      <a href="/admin/forms/register-project" class="text-gray-900 no-underline">
        <d-icon icon="arrow-left" size="1x" class="mr-3" />
        <span class="text-xl">Back To Listing Page</span>
      </a>
    </div>

    <h2>Project Details</h2>
    <view-project-details :project.sync="computedSubmissionDetails.revisedProjectInfo" :submission-source="SubmissionSource.ProjectRegistration" @save-changes="$emit('save-changes', true)" />
    <hr class="my-10">

    <h2>Submittor Details</h2>
    <div class="flex -mx-5 relative">
      <div class="w-1/2 px-5">
        <div class="mb-3">
          <p class="font-bold">
            Submitted By
          </p>
          <p v-text="computedSubmissionDetails.revisedSubmitterName" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Submitter Email
          </p>
          <p v-text="computedSubmissionDetails.revisedSubmitterEmail" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Project Role
          </p>
          <p v-text="computedSubmissionDetails.revisedSubmitterProjectRole" />
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Send Credentials to Woodworker?
          </p>
          <p>{{ computedSubmissionDetails.revisedSendCredentialsToWoodworker ? 'Yes' : 'No' }}</p>
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Send Credentials to Design Firm?
          </p>
          <p>{{ computedSubmissionDetails.revisedSendCredentialsToFirm ? 'Yes' : 'No' }}</p>
        </div>
        <div class="mb-3">
          <p class="font-bold">
            Send Credentials to Contractor?
          </p>
          <p>{{ computedSubmissionDetails.revisedSendCredentialsToContractor ? 'Yes' : 'No' }}</p>
        </div>
      </div>
    </div>

    <hr class="my-10">
    <h2>Design Firm Details</h2>
    <view-organization-details :organization.sync="computedSubmissionDetails.revisedFirm" :submission-source="SubmissionSource.ProjectRegistration" @save-changes="$emit('save-changes', true)" />

    <hr class="my-10">
    <h2>Design Firm Contact Details</h2>
    <view-contact-details :contact.sync="computedSubmissionDetails.revisedFirmContact" :submission-source="SubmissionSource.ProjectRegistration" @save-changes="$emit('save-changes', true)" />

    <hr class="my-10">
    <h2>General Contractor Details</h2>
    <view-organization-details :organization.sync="computedSubmissionDetails.revisedContractor" :submission-source="SubmissionSource.ProjectRegistration" @save-changes="$emit('save-changes', true)" />

    <hr class="my-10">
    <h2>Contractor Contact Details</h2>
    <view-contact-details :contact.sync="computedSubmissionDetails.revisedContractorContact" :submission-source="SubmissionSource.ProjectRegistration" @save-changes="$emit('save-changes', true)" />

    <hr class="my-10">
    <h2>Woodworker Details</h2>
    <view-organization-details :organization.sync="computedSubmissionDetails.revisedWoodworker" :submission-source="SubmissionSource.ProjectRegistration" @save-changes="$emit('save-changes', true)" />

    <hr class="my-10">
    <h2>Woodworker Contact Details</h2>
    <view-contact-details :contact.sync="computedSubmissionDetails.revisedWoodworkerContact" :submission-source="SubmissionSource.ProjectRegistration" @save-changes="$emit('save-changes', true)" />
  </div>
</template>

<script>
  import ViewOrganizationDetails from '@resources/scripts/patterns/formPatterns/ViewOrganizationDetails.vue';
  import ViewContactDetails from '@resources/scripts/patterns/formPatterns/ViewContactDetails.vue';
  import ViewProjectDetails from '@resources/scripts/patterns/formPatterns/ViewProjectDetails.vue';
  import { SubmissionSource } from '@resources/scripts/models/enums';

  export default {
    components: {
      ViewProjectDetails,
      ViewContactDetails,
      ViewOrganizationDetails,
    },

    props: {
      submissionDetails: {
        type: Object,
        default: () => ({}),
      },
    },

    data() {
      return {
        SubmissionSource, // enum
      };
    },

    computed: {
      computedSubmissionDetails: {
        get() {
          return this.submissionDetails;
        },
        set(value) {
          this.$emit('submissionDetails:update', value);
        },
      },
    },
  };
</script>